































































































































































































import Vue from "vue";
import Component from "vue-class-component";
import {
  MemberManagerMemberDTO,
  MemberManagerService,
  PostGroupManagerPostGroupDTO,
  PostGroupMangerService,
} from "@/common/api/index";
import PaginateModel from "@/model/paginate";
import QTableHeader from "@/common/qTableHeader.vue";
import QPaginate from "@/common/qPaginate.vue";
import QMultiSelect from "@/common/qMultilSelect.vue";
import Multiselect from "vue-multiselect";
import { namespace } from "vuex-class";
import QNotify from "@/common/qNotify";
import CreatePostGroup from "@/sites/admin/pages/members/createPostGroup.vue";

const auth = namespace("Auth");

@Component({
  name: "Member",
  components: {
    QTableHeader,
    QPaginate,
    QMultiSelect,
    Multiselect,
    CreatePostGroup,
  },
})
export default class Member extends Vue {
  @auth.Getter
  getUsingGroup!: string;

  public statuses = [
    { id: "all", name: "すべて" },
    { id: 0, name: "未承認" },
    { id: 1, name: "承認済" },
  ];
  public searchParams = {
    statuses: [],
    postGroupIds: [],
    keyword: "",
  };
  public pagination = new PaginateModel({
    page: 0,
    pageCount: 0,
    start: 0,
    end: 0,
    count: 0,
    perPage: 50,
  });
  public headers = [
    { id: "created_at", name: "申請日", order: "desc" },
    { id: "name", name: "ユーザー名", order: "" },
    { id: "comment", name: "キーワード" },
    { id: "group_names", name: "公開範囲設定" },
    { id: "", name: "" },
  ];
  public members: Array<MemberManagerMemberDTO> = [];
  public postGroups: Array<PostGroupManagerPostGroupDTO> = [];
  public selectedStatus: { id: any; name: string }[] = [];
  public selectedPostGroupId = [];

  mounted() {
    this.filter(false, {});
    this.getPostGroups();
  }

  public async getPostGroups() {
    const response = await PostGroupMangerService.postGroup({
      groupId: Number.parseInt(this.getUsingGroup),
    });
    this.postGroups = response.data.post_groups;
  }

  public filter(clear = false, addition = {}): void {
    let { name, params, query } = this.$router.currentRoute;
    if (clear) {
      query = {};
    }

    query = {
      ...query,
      ...this.searchParams,
      ...addition,
    };

    this.$router
      .replace({ name: name, params: params, query })
      .catch((error) => {
        console.error(error);
      });
    this.doSearch(query);
  }

  public doSearch(query: any): void {
    this.getList(query);
    this.$el.querySelector(".mb__responsive-table").scrollTop = 0;
  }

  public async getList(query: any) {
    const response = await MemberManagerService.member({
      ...query,
      groupId: Number.parseInt(this.getUsingGroup),
    });
    this.members = response.data.members;
    this.pagination = new PaginateModel({
      page: response.data.paginator.currentPage,
      pageCount: response.data.paginator.lastPages,
      start: response.data.paginator.currentPage,
      end: response.data.paginator.lastPages,
      count: response.data.paginator.total,
      perPage: response.data.paginator.perPage,
    });
  }

  public resetSearch() {
    this.searchParams = {
      statuses: [],
      postGroupIds: [],
      keyword: "",
    };
    this.selectedStatus = [];
    this.selectedPostGroupId = [];
    this.filter(true);
  }

  public async updateStatusPostGroup(member) {
    let message: any;
    try {
      // Call API Update status
      const response = await MemberManagerService.memberAssignPostGroup({
        groupId: Number.parseInt(this.getUsingGroup),
        memberId: member.id,
        postGroupIds: member.memberPostGroups,
      });

      message = response.message;
      QNotify.success({
        text: message,
      });
    } catch (error) {
      message = error.body.message;
      QNotify.error({
        text: message,
      });
    }
  }

  public changeStatus() {
    if (this.selectedStatus.some((item) => item.id === "all")) {
      this.searchParams.statuses = [];
      this.selectedStatus = [
        {
          id: "all",
          name: "すべて",
        },
      ];
    } else {
      this.searchParams.statuses = this.selectedStatus.map((item) => item.id);
    }
  }

  public isStatusChecked(value: any): boolean {
    return this.selectedStatus.some((status) => value.id == status.id);
  }

  public changePostGroup(value) {
    this.searchParams.postGroupIds = value.map((item) => item.id);
  }

  public isPostGroupChecked(value: any): boolean {
    return this.selectedPostGroupId.some(
      (postGroupId) => value.id == postGroupId.id
    );
  }

  public unfollow(member) {
    this.$modal.showDelete({
      text: `${member.name} さんを承認しました。`,
      // we are passing callback method for our confirm button
      onConfirm: async () => {
        let message: any;
        try {
          const response = await MemberManagerService.memberReject({
            memberId: member.id,
            groupId: Number.parseInt(this.getUsingGroup),
          });

          message = response.message;
          QNotify.success({
            text: message,
          });
          this.filter();
        } catch (error) {
          message = error.body;
          QNotify.error({
            text: message,
          });
        }
      },
      onClose: () => {
        console.log("onClose");
      },
    });
  }

  public follow(member) {
    this.$modal.show({
      text: `${member.name} さんを承認しました。`,
      // we are passing callback method for our confirm button
      onConfirm: async () => {
        let message: any;
        try {
          const response = await MemberManagerService.memberApproval({
            memberId: member.id,
            groupId: Number.parseInt(this.getUsingGroup),
          });
          message = response.message;

          // Show message
          QNotify.success({
            text: message,
          });

          this.filter();
        } catch (error) {
          message = error.body;
          QNotify.error({
            text: message,
          });
        }
      },
      onClose: () => {
        console.log("onClose");
      },
    });
  }

  showModalCreatePostGroup() {
    (this.$refs.createPostGroup as CreatePostGroup).show();
  }

  modalSave() {
    this.resetSearch();
    this.getPostGroups();
  }
}
